// extracted by mini-css-extract-plugin
export default {"error":"form-modal_error__MJwWQ"};